module.exports = __webpack_public_path__ + "img/win_item11.9b91d972.png";